import { render, staticRenderFns } from "./AdminPostNew.vue?vue&type=template&id=0135c7d9&scoped=true&"
import script from "./AdminPostNew.vue?vue&type=script&lang=js&"
export * from "./AdminPostNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminPostNew.vue?vue&type=style&index=0&id=0135c7d9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135c7d9",
  null
  
)

export default component.exports